export const ADD = {
  TH: 'เพิ่ม',
  EN: 'Add ',
}

export const EDIT = {
  TH: 'แก้ไข',
  EN: 'Edit ',
}

export const SUCCESS = {
  TH: 'สำเร็จ !',
  EN: 'Success !',
}

export const NO_LIST = {
  TH: 'ไม่มีรายการ',
  EN: 'No ',
}

export const ISSUE_ERROR = {
  ERROR : {
    TH: 'ล้มเหลว !',
    EN: 'Error !',
  },
  TEXT: {
    TH: 'ไฟล์นี้ขนาดใหญ่เกินไป ไม่สามารถถูกอัปโหลด',
    EN: 'The file is too large and cannot be uploaded.',
  }
}

export const ORDER_MANAGER = {
  VALUE: {
    CATERING: 'cateringTab',
    EQUIPMENT: 'equipmentTab',
    FACILITY: 'facilityTab',
    SUCCESS: 'SUCCESS',
    END_MEETING_SUCCESS: 'endMeetingSuccess'
  },
  TAB: {
    CATERING: {
      TH: 'อาหารและเครื่องดื่ม',
      EN: 'Catering',
    },
    EQUIPMENT: {
      TH: 'อุปกรณ์',
      EN: 'Equipment',
    },
    FACILITY: {
      TH: 'สิ่งอำนวยความสะดวก',
      EN: 'Facilities',
    },
  },
  STATUS: {
    WAITING: {
      TH: 'รอ',
      EN: 'Waiting',
    },
    ON_GOING: {
      TH: 'กำลังดำเนินการ',
      EN: 'On-Going',
    },
    COMPLETED: {
      TH: 'เสร็จสิ้น',
      EN: 'Completed',
    }
  },
  EDIT: {
    TH: 'แก้ไข',
    EN: 'Edit',
  },
}

export const ORDER_MODAL = {
  VALUE: {
    DRINK: 0,
    FOOD: 1,
    EQUIPMENT: 2,
  },
  TAB: {
    DRINK: {
      TH: 'เครื่องดื่ม',
      EN: 'Drink',
    },
    FOOD: {
      TH: 'อาหาร',
      EN: 'Food',
    },
    EQUIPMENT: {
      TH: 'อุปกรณ์',
      EN: 'Equipment',
    },
  },
}

export const ORDER_TYPE = {
  DRINK: {
    VALUE: 0,
    TEXT: {
      TH: 'เครื่องดื่ม',
      EN: 'Drink',
    }
  },
  FOOD: {
    VALUE: 1,
    TEXT: {
      TH: 'อาหาร',
      EN: 'Food',
    }
  },
  EQUIPMENT: {
    VALUE: 2,
    TEXT: {
      TH: 'อุปกรณ์',
      EN: 'Equipment',
    }
  },
  FACILITY: {
    VALUE: 3,
    TEXT: {
      TH: 'สิ่งอำนวยความสะดวก',
      EN: 'Facility',
    }
  },
}

export const ORDER_MANAGER_TAB = {
  [ORDER_MANAGER.VALUE.CATERING]: {
    value: ORDER_MANAGER.VALUE.CATERING,
    title: ORDER_MANAGER.TAB.CATERING,
  },
  [ORDER_MANAGER.VALUE.EQUIPMENT]: {
    value: ORDER_MANAGER.VALUE.EQUIPMENT,
    title: ORDER_MANAGER.TAB.EQUIPMENT,
  },
  [ORDER_MANAGER.VALUE.FACILITY]: {
    value: ORDER_MANAGER.VALUE.FACILITY,
    title: ORDER_MANAGER.TAB.FACILITY,
  },
}

export const ORDER_ITEM_STATUS_VALUE = {
  WAITING: 1,
  ON_GOING: 2,
  COMPLETE: 0,
}

export const ORDER_ITEM_STATUS = {
  [ORDER_ITEM_STATUS_VALUE.WAITING]: {
    TEXT: {
      TH: 'กำลังรอ',
      EN: 'Waiting',
    }
  },
  [ORDER_ITEM_STATUS_VALUE.ON_GOING]: {
    TEXT: {
      TH: 'กำลังดำเนินการ',
      EN: 'On-Going',
    }
  },
  [ORDER_ITEM_STATUS_VALUE.COMPLETE]: {
    TEXT: {
      TH: 'เสร็จสิ้น',
      EN: 'Complete',
    }
  },
}

export const ORDER_ITEM_DETAIL = {
  ORDER: {
    TH: 'ออเดอร์',
    EN: 'Order',
  },
  EDIT: {
    TH: 'แก้ไข',
    EN: 'Edit',
  },
}

export const ORDER_MODAL_ACTION_TEXT = {
  BACK: {
    TH: 'กลับ',
    EN: 'Back',
  },
  ADD: {
    TH: 'เพิ่ม',
    EN: 'Add',
  },
  SEND: {
    TH: 'ส่ง',
    EN: 'Send',
  },
  SAVE_CHANGE: {
    TH: 'บันทึกการเปลี่ยนแปลง',
    EN: 'Save Changes',
  },
  CONFIRM: {
    TH: 'ยืนยัน',
    EN: 'Confirm',
  },
  CONFIRM_ORDER: {
    TH: 'ยืนยันออเดอร์',
    EN: 'Confirm Order'
  },
  DONE: {
    TH: 'สำเร็จ',
    EN: 'Done',
  },
  ARE_YOU_SURE: {
    TH: 'คุณแน่ใจหรือไม่ ?',
    EN: 'Are you sure ?',
  },
  YES_CANCEL_ORDER: {
    TH: 'ใช่, ลบรายการ',
    EN: 'Yes, Cancel Order',
  },
  DO_YOU_WANT_TO_CANCEL_ORDER: {
    TH: 'คุณต้องการลบรายการนี้ใช่ไหม ?',
    EN: 'Do you want to cancel this order ?',
  }
}

export const ORDER_ACTION_TEXT = {
  [ORDER_MANAGER.VALUE.CATERING]: {
    ADD: {
      TH: 'รายการอาหารและเครื่องดื่มถูกเพิ่มแล้ว',
      EN: 'Catering order have been updated',
    },
    EDIT: {
      TH: 'การเปลี่ยนแปลงรายการถูกแก้ไขสำเร็จ',
      EN: 'Your changed have been updated successfully',
    },
    CANCEL: {
      TH: 'รายการถูกยกเลิกแล้ว',
      EN: 'Your order has been canceled',
    },
  },
  [ORDER_MANAGER.VALUE.EQUIPMENT]: {
    ADD: {
      TH: 'รายการอุปกรณ์ถูกเพิ่มแล้ว',
      EN: 'Equipment order have been updated',
    },
    EDIT: {
      TH: 'การเปลี่ยนแปลงรายการถูกแก้ไขสำเร็จ',
      EN: 'Your changed have been updated successfully',
    },
    CANCEL: {
      TH: 'รายการถูกยกเลิกแล้ว',
      EN: 'Your order has been canceled',
    },
  },
  [ORDER_MANAGER.VALUE.FACILITY]: {
    REPORT: {
      TH: 'ปัญหาถูกส่งไปยังผู้รับผิดชอบแล้ว',
      EN: 'Issue has been sent to responsible person',
    },
  },
  [ORDER_MANAGER.VALUE.SUCCESS]: {
    SUCCESS: {
      TH: 'ขยายเวลาการประชุมของคุณแล้ว',
      EN: 'Your meeting time has been extended.',
    }
  },
  [ORDER_MANAGER.VALUE.END_MEETING_SUCCESS]: {
    SUCCESS: {
      TH: 'การประชุมของคุณเสร็จสิ้นแล้ว',
      EN: 'Your meeting is completed.',
    }
  }
}

export const EXTEND_MEETING = {
  HEADER: {
    TH: 'ขยายการประชุม',
    EN: 'Extend Meeting',
  },
  CONTENT: {
    TH: 'คุณแน่ใจหรือไม่ว่าต้องการขยายเวลาการประชุมนี้',
    EN: 'Are you sure you want to extend this meeting?',
  },
  BUTTON_EXTEND: {
    TH: 'ขยาย',
    EN: 'Extend',
  },
  ERROR_EXTEND: {
    TH: 'ไม่สามารถขยายการประชุมได้เนื่องจากมีการประชุมอื่นอยู่',
    EN: 'It is not possible to extend the meeting due to there was another meeting',
  }
}

export const ERROR_ORDER = {
  DELETE : {
    TH: 'เกิดข้อผิดพลาดกับคำสั่งยกเลิกของคุณ',
    EN: 'There was an error with your cancellation order.',
  },
  EDIT : {
    TH: 'ไม่สามารถอัปเดตคำสั่งซื้อได้',
    EN: 'Unable to update order',
  },
  CREATE: {
    TH: 'ไม่สามารถสร้างการสั่งซื้อ',
    EN: 'Unable to create order',
  }
}

export const OTHER = 'others'
